// BrokerSearchBox.js
import React from 'react';
//import DOMPurify from 'dompurify';
import './BrokerSearchBox.css';

const BrokerSearchBox = ({ headline = '', subline = '', linkText = '', linkTargetUrl = ''}) => (
  <div className="wrapper container brokersearchbox">
      <div className="l-container l-container--full-width" >
          <div className="l-grid l-grid--max-width">
              <div className="c-wrapper ">
                  <div className="parsys">
                      <div className="text-column container">
                          <div className="c-text-column-flex" align="center">
                              <div>
                                  <h1 className="c-heading  c-heading--page  c-link--capitalize u-text-hyphen-none">
                                      <span className='t-white'>{headline}</span>
                                  </h1>
                              </div>
                              <div>
                                  <div className="c-copy  c-copy--large   u-text-hyphen-manual">
                                          <span className='t-white'>{subline}</span>
                                  </div>
                              </div>
                              <div className="c-text-column-flex c-button-bottom">
                                  <a href={linkTargetUrl} target="_blank" rel="noreferrer" aria-label="Contacter un courtier"
                                    className=" c-button c-button--negative c-button--link c-button-link-center-align"
                                    data-component-id="root/parsys/wrapper_copy_8978668/wrapper/grid_1_copy/text_column/button">
                                      {linkText}                                        
                                  </a>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
);

export default BrokerSearchBox;